import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import Cards from "./pages/Cards";
import Fortune from "./pages/Fortune";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/cards/:desk/:number" element={<Cards />} />
          <Route path="/fortune" element={<Fortune />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
